export enum VARIANTS {
  control = 'control',
  variant1 = 'variant1',
  variant2 = 'variant2',
}
